import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/helper';
import v1 from './main-v1.module.css';
import v2 from './main-v2.module.css';

export default function Main(props: PropsWithChildren) {
  return <div className={cn(v1.Main, v2.Main)}>{props.children}</div>;
}
